import type { ComponentType } from "react";

const modules = import.meta.glob<
	{ default: ComponentType<unknown> }
>("./*.tsx", { eager: true });

export const Components = Object.fromEntries(
	Object.entries(modules).map(([filePath, module]) => {
		const name = filePath.replace(/^\.\//, "").replace(/\.tsx$/, "");
		return [name, module.default];
	})
) as Record<string, ComponentType<unknown>>;
